import { Button, EmbeddedContentDefinition } from 'modules/graphql';
import { ExpandableChevron } from 'modules/templateEditor/common';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { useState } from 'react';
import { BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { Delete16 } from 'ui/icons';
import { ActionsInput } from './ActionsInput';
import { ButtonWrapper, Container, Header } from './styles';
import { TitleInput } from './TitleInput';
import { formatLabelForId } from '../../utils';

type Props = {
  button: Button;
  hasError: boolean;
  index: number;
};

export const ActionButtonTile = ({ button, hasError, index }: Props) => {
  const { liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const { elements } = liveTemplate.mediumData as EmbeddedContentDefinition;
  const actionButtons = elements?.buttons || [];

  const [isExpanded, setIsExpanded] = useState(true);

  const setActionButtons = (updatedActions: Button[]) => {
    const newElements = {
      ...elements,
      buttons: updatedActions.length ? updatedActions : null,
    };
    setCurrentMediumField('elements', newElements);
  };

  const handleDelete = () => {
    const updatedList = [...actionButtons];
    updatedList.splice(index, 1);
    setActionButtons(updatedList);
  };

  return (
    <Container data-test={`action-button-tile-${formatLabelForId(button?.title ?? '')}`}>
      <Header>
        <TitleInput button={button} index={index} />
        <ButtonWrapper>
          <IconButton
            onClick={handleDelete}
            variant={BUTTON_VARIANTS.GHOST}
            size={BUTTON_SIZES.SMALL}
          >
            <Delete16 />
          </IconButton>
          <ExpandableChevron isExpanded={isExpanded} onClick={setIsExpanded} />
        </ButtonWrapper>
      </Header>
      {isExpanded && <ActionsInput button={button} hasError={hasError} index={index} />}
    </Container>
  );
};
